import MyTabs from '../../../components/MyTabs';
import ECONBasic from './Basic';


const Economics = () => {

    const tabs = [
        { id: "basic", title: "Basic", Component: ECONBasic },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default Economics;